module.exports = __webpack_public_path__ + "img/master.42c3fa12.svg";